import React, { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AppDispatch, RootState } from '../../../store/store';
import { getUUID } from '../../../utils/UUID';
import Spinner from '../../atoms/Spinner/Spinner';
import { CollectionResponseDto } from '../../../store/landscapeAPI/collection/dto/response/collection-response.dto';
import { CollectionSaveRequestDto } from '../../../store/landscapeAPI/collection/dto/request/collection-save-request.dto';
import { saveCollection } from '../../../store/landscapeAPI/collection/reducers/collection.slice';
import { ReportingDetailsCollectionsAddTemplate } from '../../templates';
import { LocalesLanguagesConstants } from '../../../locales/locales';
import { PromiseSettledResult } from '../../../utils/types/types';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';
import { MediaSaveResponseDto } from '../../../store/mediaAPI/media/dto/response/media-save-response';
import { saveMedia } from '../../../store/mediaAPI/media/reducers/media.slice';

// import styles from './ReportingDetailsCollectionsAddPage.module.css';

interface ReportingDetailsCollectionsAddPageProps {}

const ReportingDetailsCollectionsAddPage: FC<
  ReportingDetailsCollectionsAddPageProps
> = () => {
  const [collection, setCollection] = useState<CollectionResponseDto>({
    name: '',
    id: getUUID(),
    versionId: 0,
    createdByUserId: '',
    createdOnDateTimeUtc: '',
    language: '',
    published: true,
    icon: '',
  });

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [imageMeta, setImageMeta] = useState<ImageMeta>();

  const handleOnChange = (collection: CollectionResponseDto) => {
    setCollection(collection);
  };

  const handleImageOnChange = (imageMeta: ImageMeta) => {
    setImageMeta(imageMeta);
  };

  const { status } = useSelector((state: RootState) => state.collectionSlice);

  const [selectedLanguage, setLanguage] = useState<LocalesLanguagesConstants>(
    LocalesLanguagesConstants.en
  );

  const [fromLanguage, setFromLanguage] = useState<LocalesLanguagesConstants>(
    LocalesLanguagesConstants.en
  );

  const [toLanguage, setToLanguage] = useState<LocalesLanguagesConstants>(
    LocalesLanguagesConstants.en
  );

  const generateAllTranslations: () => Promise<
    PromiseSettledResult<void>[]
  > = async () => {
    const rejectedResults: PromiseSettledResult<void>[] = [
      {
        status: 'rejected',
        reason: new Error(
          'Must save verification status before generating translation'
        ),
      },
    ];

    return Promise.reject(rejectedResults);
  };

  const generateTranslation = async () => {};

  const handleAddCollection = async (collection: CollectionResponseDto) => {
    let icon: MediaSaveResponseDto = {
      href: '',
    };

    if (collection.icon && collection.icon !== '' && imageMeta) {
      const formData = new FormData();
      formData.append(
        'file',
        new Blob([collection.icon], {
          type: imageMeta?.imageType ?? 'image/png',
        }),
        imageMeta?.imageSrc
      );
      icon = (await dispatch(saveMedia(formData)))
        .payload as MediaSaveResponseDto;
    }

    const data: CollectionSaveRequestDto = {
      id: collection.id,
      name: collection.name,
      published: collection.published,
      icon: icon.href,
    };

    const response = await dispatch(
      saveCollection({ saveRequest: data, language: selectedLanguage })
    );
    const newCollection = response.payload as CollectionResponseDto;

    navigate(`/reporting-details/collections/${newCollection.id}/edit`);
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <ReportingDetailsCollectionsAddTemplate
      data={collection}
      handleAddCollection={handleAddCollection}
      handleOnChange={handleOnChange}
      handleImageOnChange={handleImageOnChange}
      setLanguage={setLanguage}
      selectedLanguage={selectedLanguage}
      fromLanguage={fromLanguage}
      setFromLanguage={setFromLanguage}
      toLanguage={toLanguage}
      setToLanguage={setToLanguage}
      generateTranslation={generateTranslation}
      generateAllTranslations={generateAllTranslations}
    />
  );
};

export default ReportingDetailsCollectionsAddPage;
